import React from "react";
import { FormattedMessage } from "react-intl";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { Card } from "../common/card/card";
import { Caption, Value, CardTitle } from "./workOrderDetails";

const WorkOrderAssignementInfoSection = ({ classes, title, assignmentInfo, accessID }) => {
    return (
        <Card>
            <Grid container>
                <Grid item xs={12}>
                    <CardTitle style={{ margin: "0.3rem 0 1rem" }}>
                        <FormattedMessage id={title} defaultMessage="Assignment Title" description="Assignment Title" />
                        {accessID && <>: {accessID}</>}
                    </CardTitle>
                </Grid>
                {assignmentInfo.map((info) => (
                    <Grid container>
                        <Grid item xs={12}>
                            <div style={{ border: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "1rem" }}></div>
                        </Grid>
                        <Grid item xs={1}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-type-title"
                                    defaultMessage="Type"
                                    description="Admin Assignment information Type title"
                                />
                            </Caption>
                            <Value>{info?.type || "-"}</Value>
                        </Grid>
                        <Grid item xs={1}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-cable-title"
                                    defaultMessage="Cable"
                                    description="Admin Assignment information Cable title"
                                />
                            </Caption>
                            <Value>{info?.cable || "-"}</Value>
                        </Grid>
                        <Grid item xs={1}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-pair-title"
                                    defaultMessage="Pair"
                                    description="Admin Assignment information Pair title"
                                />
                            </Caption>
                            <Value>{info?.pair || "-"}</Value>
                        </Grid>
                        <Grid item xs={2}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-termainal-id-title"
                                    defaultMessage="Terminal ID"
                                    description="Admin Assignment information Terminal ID title"
                                />
                            </Caption>
                            <Value>{info?.terminalId || "-"}</Value>
                        </Grid>
                        <Grid item xs={2}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-bc-or-cc-title"
                                    defaultMessage="BP/CC"
                                    description="Admin Assignment information BP/CC title"
                                />
                            </Caption>
                            <Value>{info?.bpcc || "-"}</Value>
                        </Grid>
                        <Grid item xs={3}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-terminal-title"
                                    defaultMessage="Terminal"
                                    description="Admin Assignment information Terminal title"
                                />
                            </Caption>
                            <Value>{info?.terminal || "-"}</Value>
                        </Grid>
                        <Grid item xs={2} className={classes.fiedlStyle}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.assignment-info-terminal-remark-title"
                                    defaultMessage="Terminal Remark"
                                    description="Terminal Remark"
                                />
                            </Caption>
                            <Value>{info?.terminalRemark || "-"}</Value>
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
};

export default WorkOrderAssignementInfoSection;
